<template>
  <div class="section">
    <h2 class="section-title">{{ title }}</h2>
    <slot />
  </div>
</template>

<script>
export default {
  name: "Section",
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.section {
  margin-bottom: 12mm;
}

.section:last-child {
  margin-bottom: 0;
}

.section-title {
  font-size: 18pt;
  font-weight: 700;
  margin-bottom: 6mm;
  letter-spacing: -0.5px;
}
</style>
